/* ==========================================================================
   Calendar > Config
   ========================================================================== */

/* Config base */
const config = {
    component: 'Calendar',
    init: true,
    domEvents: true,
    mode: 'range',
    language: 'es',
    cssValid: 'is-valid',
    cssError: 'has-error',
    onChange: [],
    defaultDate: undefined
};

module.exports = config;
